import React from 'react';
/**
 * Isolates a single AI response block's render.
 *
 * A malformed block (e.g. a data_table cell that is an object — React error
 * #31) must not unmount the entire chat widget. This boundary catches the
 * render error and shows a small inline fallback so the rest of the
 * conversation stays usable.
 */
export class BlockErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        var _a;
        // eslint-disable-next-line no-console
        console.error(`[AIAgentMessage] block "${(_a = this.props.blockType) !== null && _a !== void 0 ? _a : 'unknown'}" failed to render:`, error);
    }
    render() {
        if (this.state.hasError) {
            return (React.createElement("div", { className: "ai-agent-message__block-error", role: "alert" }, "This part of the response couldn't be displayed."));
        }
        return this.props.children;
    }
}
